// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Sluiten',
  error: () => 'Fout',
  warn: () => 'Waarschuwing',
  info: () => 'Informatie',
  confirmation: () => 'Bevestiging',
  progressIndeterminate: () => 'In uitvoering',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Tussen ' + p['FROM_SECTION'] + ' en ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Geen overeenkomende sectie gevonden.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Druk op Enter om waarde te selecteren.',
  indexer_touchInstructionText: () =>
    'Dubbeltik en houd vast om gebarenmodus te activeren. Sleep vervolgens omhoog of omlaag om waarde aan te passen.',
  inputPassword_show: () => 'Wachtwoord tonen',
  inputPassword_hide: () => 'Wachtwoord verbergen',
  inputPassword_hidden: () => 'Wachtwoord verborgen',
  formControl_clear: () => 'Wissen',
  formControl_loading: () => 'Bezig met laden',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximumlengte ' + p['MAX_LENGTH'] + ' is overschreden.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' tekens over',
  formControl_requiredMessageDetail: () => 'Voer een waarde in.',
  select_requiredMessageDetail: () => 'Selecteer een waarde.',
  select_noMatchesFound: () => 'Geen treffers gevonden.',
  select_oneMatchFound: () => 'Eén match gevonden.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' matches gevonden',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' of meer matches gevonden',
  selectMultiple_selectedValues: () => 'Geselecteerde waarden',
  selectMultiple_showSelectedValues: () => 'Alleen geselecteerde waarden tonen',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' geselecteerde waarden',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    "Klik op 'Backspace' of 'Delete' om de geselecteerd waarde te verwijderen.",
  selectMultiple_apply: () => 'Toepassen',
  selectMultiple_back: () => 'Terug',
  selector_selected: () => 'Selectievakje ingeschakeld',
  selector_unselected: () => 'Selectievakje niet ingeschakeld',
  userAssistance_learnMore: () => 'Meer info',
  userAssistance_required: () => 'Vereist',
  filePicker_singleFileUploadError: () => 'Upload één bestand per keer',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'U kunt geen bestanden uploaden van het type ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'U kunt geen bestanden uploaden van dit type: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'onbekend',
  filePicker_dropzonePrimaryText: () => 'Slepen en neerzetten',
  filePicker_dropzoneSecondaryText: () => 'Selecteer een bestand of zet er een hier neer.',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selecteer bestanden of zet deze hier neer.',
  filePicker_addFiles: () => 'Bestanden toevoegen',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Vergroten',
  inputNumber_decrease: () => 'Verkleinen',
  inputNumber_converterParseError: () => 'Voer een getal in.',
  noData_message: () => 'Geen items om weer te geven',
  message_navigationFromMessagesRegion: () =>
    'Berichtenregio wordt geopend. Druk op F6 om terug te navigeren naar het element dat hiervoor de focus had.',
  message_navigationToMessagesRegion: () =>
    'Berichtenregio bevat nieuwe berichten. Druk op F6 om naar de regio met de laatste berichten te gaan.',
  messageToast_allMessagesClosed: () => 'Alle toastmeldingen zijn gesloten.',
  expandableList_groupCollapse: () => 'Samengevouwen',
  expandableList_groupExpand: () => 'Uitgevouwen',
  expandableList_expandCollapseInstructionText: () =>
    'Gebruik de pijltoetsen om uit te vouwen en samen te vouwen',
  list_suggestion: () => 'Suggestie',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Stap ' + p['currentStep'] + ' van ' + p['numberOfSteps'],
  train_current: () => 'Huidig',
  train_visited: () => 'Bezocht',
  train_not_visited: () => 'Niet bezocht',
  train_message_type: () => 'Berichttype',
  viz_drillable: () => 'Inzoombaar',
  dataVisualization_stateSelected: () => 'Geselecteerd',
  dataVisualization_stateUnselected: () => 'Niet geselecteerd',
  dataVisualization_noData: () => 'Er zijn geen gegevens om weer te geven.'
};
export default bundle;
